export * from './location-hierarchy.component';
 


// WEBPACK FOOTER //
// ./src/app/pages/shared/components/location-hierarchy/index.ts